export default {
    props: {
        userId: {
            type: String,
            default: null
        },
        userJson: {
            type: String,
            default: null
        }
    },

    computed: {
        user: function() {
            if (this.userJson) {
                return JSON.parse(this.userJson);
            }

            return null;
        }
    }
};
